@if (consent.bannerVisible()) {
  <section class="ls-consent" role="region" aria-live="polite" [attr.aria-label]="'CONSENT.TITLE' | translate">
    <p class="ls-consent__text">
      <strong>{{ 'CONSENT.TITLE' | translate }}</strong>
      {{ 'CONSENT.TEXT' | translate }}
      <a [routerLink]="['/', lang(), routeName.Confidentialite]">{{ 'CONSENT.LEARN_MORE' | translate }}</a>
    </p>
    <div class="ls-consent__actions">
      <button type="button" class="ls-consent__btn" (click)="consent.refuse()">
        {{ 'CONSENT.REFUSE' | translate }}
      </button>
      <button type="button" class="ls-consent__btn ls-consent__btn--primary" (click)="consent.accept()">
        {{ 'CONSENT.ACCEPT' | translate }}
      </button>
    </div>
  </section>
}
